<template>
    <v-autocomplete
        dense
        outlined
        v-model="select"
        @input="HandleInput"
        :items="items"
        :search-input.sync="search"
        :item-text="DisplayName"
        :readonly="readonly"
        return-object
        :clearable="!readonly"
        no-filter
        flat
        hide-no-data
        hide-details
        :label="label || $t('Region')"
    ></v-autocomplete>
</template>

<script>
import regionService from '@/service/region-service.js';

export default {
    props: {
        value: Number,
        label: String,
        readonly: Boolean,
    },
    data() {
        return {
            items: [],
            search: null,
            select: null,
            timer: null,
            getDataAbort: null,
        };
    },
    mounted() {
        if (this.value) {
            this.SetSelected(this.value);
        }
    },
    watch: {
        search(value, oldValue) {
            if (value !== oldValue) {
                if (
                    value !== (this.select && this.select.code) &&
                    value !== this.DisplayName(this.select)
                ) {
                    clearTimeout(this.timer);
                    this.items = [];
                    if (this.getDataAbort) {
                        this.getDataAbort.abort();
                    }
                    if (value) {
                        this.timer = setTimeout(
                            () => this.QuerySelections(value),
                            300
                        );
                    }
                }
            }
        },
        value(val) {
            if (!val) {
                this.search = null;
                this.select = null;
                this.items = [];
            } else {
                this.SetSelected(val);
            }
        },
    },
    methods: {
        async GetData(filter, callback) {
            if (this.getDataAbort) {
                this.getDataAbort.abort();
                this.items = [];
            }
            this.getDataAbort = new AbortController();
            regionService
                .getData(
                    1,
                    20,
                    filter,
                    this.getDataAbort && this.getDataAbort.signal
                )
                .then((response) => callback(response))
                .finally(() => {
                    this.getDataAbort = null;
                });
        },
        QuerySelections(search) {
            this.GetData(
                { name: search },
                (response) => (this.items = response.data)
            );
        },
        HandleInput() {
            this.$emit('input', this.select && this.select.code);
        },
        SetSelected(value) {
            if (value && (!this.select || !this.select.code || value !== this.select)) {
                this.GetData({ code: value }, (response) => {
                    var data = response.data.filter((d) => d.code == value);
                    if (data.length > 0) {
                        this.items = data;
                        this.select = data[0];
                    }
                });
            }
        },
        DisplayName(item) {
            if (item) {
                return item.name || '';
            }
            return null;
        },
    },
};
</script>

<style>
</style>